import { useState } from 'react';
import { Btn } from '../components/Btn.tsx';
import { AuthSplitLayout, AuthInfoChip } from '../components/AuthSplitLayout.tsx';
import { useAdminAuth } from '../lib/auth/admin.tsx';

// Post-logout landing page. This route exists specifically because it does NOT
// auto-start SSO: /admin/login does, so sending a signed-out admin there would
// immediately re-authenticate them against the still-live central session and
// they could never sign out.
//
// Sign-in from here is an explicit click, never automatic.
export function AdminSignedOut() {
  const { signInWithSso } = useAdminAuth();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSignIn() {
    setSubmitting(true);
    setError(null);
    try {
      await signInWithSso();
    } catch {
      setError('Sign-in is unavailable right now. Please try again shortly.');
      setSubmitting(false);
    }
  }

  return (
    <AuthSplitLayout variant="admin">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1.5">
          <h2 className="text-2xl text-slate-900">You&rsquo;ve been signed out</h2>
          <p className="text-sm text-slate-500">
            Your session on this portal has ended. Close this tab if you&rsquo;re finished.
          </p>
        </div>

        {error && (
          <div className="rounded-lg border border-amber-200 bg-amber-50 px-3.5 py-3 text-sm text-amber-800">
            {error}
          </div>
        )}

        <div className="flex flex-col gap-3">
          <Btn
            type="button"
            loading={submitting}
            onClick={() => void onSignIn()}
            className="w-full"
            style={{ borderRadius: 10, height: 48 }}
          >
            Sign in again
          </Btn>
          <AuthInfoChip tone="neutral">
            If you&rsquo;re on a shared computer, close the browser to make sure your organisation
            sign-in is also cleared.
          </AuthInfoChip>
        </div>
      </div>
    </AuthSplitLayout>
  );
}
